// extracted by mini-css-extract-plugin
module.exports = {"container":"ActionTags_container__zFwEE","title":"ActionTags_title__3b5_5","tagList":"ActionTags_tagList__3JLeV"};